import styled, { css } from 'styled-components'

interface IconWrapperProps {
  color?: string
  variant: 'primary' | 'secondary'
  $buttonType?: 'prev' | 'next'
  iconSize?: string
}
interface ClickAreaProps {
  clickAreaSize: string
}

export const ClickArea = styled.div<ClickAreaProps>`
  position: relative;
  width: ${({ clickAreaSize }) => clickAreaSize};
  height: ${({ clickAreaSize }) => clickAreaSize};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const WrapIcon = styled.div<IconWrapperProps>`
  svg {
    display: block;
    width: ${({ iconSize }) => {
      return iconSize
    }};
    height: ${({ iconSize }) => {
      return iconSize
    }};
    fill: ${({ theme, variant, color }) => {
      return `${
        color ??
        (variant === 'primary'
          ? theme.colors.text.primary
          : theme.colors.background)
      } !important`
    }};
  }

  g,
  path {
    transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
    stroke: ${({ theme, variant, color }) => {
      return `${
        color ??
        (variant === 'primary'
          ? theme.colors.text.primary
          : theme.colors.background)
      } !important`
    }};
  }

  ${({ $buttonType }) => {
    return (
      $buttonType === 'prev' &&
      css`
        transform: rotate(90deg);
      `
    )
  }}

  ${({ $buttonType }) => {
    return (
      $buttonType === 'next' &&
      css`
        transform: rotate(270deg);
      `
    )
  }}
`

export const Badge = styled.div`
  user-select: none;
  font-family: ${({ theme }) => theme.fonts.brand};
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  background-color: ${({ theme }) => theme.colors.primary};
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.background};
  padding: 0.25rem;
  border-radius: 9999px;
  min-width: 1.5rem;
  line-height: 1rem;
  text-align: center;
  font-weight: bold;
`
